module.exports = __webpack_public_path__ + "static/media/background.b32a15e6.png";